var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading active"},[_c('div',{staticClass:"icon"},[_c('i',{staticClass:"fa fa-circle-o-notch fa-spin"})])])
}]

export { render, staticRenderFns }